import React from 'react';
import { Collapse } from 'antd';
import { CollapseProps } from 'antd/lib';
import WorkingTime from '../WorkingTime';
import { safeJSONParse } from 'utils/generalHelpers';
import { FarmDeliveries, OpenHours } from 'types/FarmData';
import { FarmDeliveriesWrapper, DeliveryContentWrapper } from './style';
import { Icon } from 'ui';
import { useIntl } from 'react-intl';

interface DeliveriesProps {
  daysOfWeek: string[];
  deliveries: FarmDeliveries[] | undefined;
}

const transformAddress = (address: string | null | undefined): string => {
  if (!address || address === ' ') {
    return '';
  }

  if (address.slice(address.length - 2).includes('.,')) {
    return address;
  }

  return `${address}.,`;
};

const Deliveries: React.FC<DeliveriesProps> = ({ daysOfWeek, deliveries }) => {
  const intl = useIntl();

  const items: CollapseProps['items'] = deliveries
    ? deliveries
        .filter((delivery) => delivery.status !== false)
        .map((delivery) => {
          const parsedOpenHours = safeJSONParse<Record<string, OpenHours>>(
            delivery.open_hours,
            {}
          );
          const hasOpenHours = Object.keys(parsedOpenHours).length > 0;

          return {
            key: delivery.id,
            label: intl.formatMessage({ id: `delivery.${delivery.type}` }),
            children: (
              <DeliveryContentWrapper>
                {delivery.price && (
                  <div className="delivery-price">
                    {`${intl.formatMessage({ id: 'delivery.price' })}${intl.formatNumber(delivery.price, {
                      style: 'currency',
                      currency: 'EUR',
                    })}`}
                  </div>
                )}
                {delivery.description && (
                  <div className="delivery-description">
                    {delivery.description}
                  </div>
                )}
                {hasOpenHours && (
                  <WorkingTime
                    workingTime={parsedOpenHours as unknown as OpenHours[]}
                    workingTimeTitle={`${transformAddress(delivery.address)} ${delivery.phone ? delivery.phone : ''}`}
                    daysOfWeek={daysOfWeek}
                  />
                )}
              </DeliveryContentWrapper>
            ),
          };
        })
    : [];

  return (
    <FarmDeliveriesWrapper className="farm-partner">
      <Collapse
        expandIconPosition="end"
        className="custom-collapse"
        items={items}
        expandIcon={({ isActive }) => (
          <Icon
            name={'arrow-down'}
            type={'avarage'}
            style={{
              transition: 'transform 0.3s',
              transform: isActive ? 'rotate(180deg)' : '',
            }}
          />
        )}
      />
    </FarmDeliveriesWrapper>
  );
};

export default Deliveries;
